import styles from './ShowTopicCheckbox.module.css'

const ShowTopicCheckbox = ({onClick, isOn = false}) => {

    return (
        <div className={isOn?styles.component_on:styles.component_off} onClick={(e)=> {onClick(); e.stopPropagation()}} >
            {
                isOn? (
                    <>
                    <i className="fa-solid fa-align-justify"></i>
                    <div>TITLE ON</div>
                    </>
                ) : (
                    <>
                    <i className="fa-solid fa-align-justify"></i>
                    <div>TITLE OFF</div>
                    </>
                )
            }
            
        </div >

    );
}

export default ShowTopicCheckbox;